// Notes that must never be lost (DESIGN §3): a last-chance keepalive save while the page goes away, and an unsaved
// draft kept on this device until a save is confirmed (survives a 401 → sign in again, a crash or a closed tab).
import { todayISO } from '../../shared/dates.js';
import { MODE, dispatch, getCurrentPerson } from '../store.js';

// Page going away (hidden / closed / reloaded): server mode sends a keepalive request the browser completes after unload
// (a queued dispatch() would be cancelled). Local mode writes through the store.
export function sendOnUnload(type, payload) {
  if (MODE !== 'server') {
    dispatch(type, payload, { toast: false }).catch(() => {});
    return;
  }
  try {
    fetch('/api/actions', {
      method: 'POST',
      keepalive: true,
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, payload, today: todayISO(), actorId: getCurrentPerson() }),
    }).catch(() => {});
  } catch {
    // Nothing more can be done while unloading.
  }
}

const DRAFT_PREFIX = 'frazier-notes-draft:';

// → { value, base } (base = the stored text the draft was typed on) or null.
export function readDraft(key) {
  try {
    const d = JSON.parse(localStorage.getItem(DRAFT_PREFIX + key) || 'null');
    return d && typeof d.value === 'string' && typeof d.base === 'string' ? d : null;
  } catch {
    return null;
  }
}

export function writeDraft(key, value, base) {
  try { localStorage.setItem(DRAFT_PREFIX + key, JSON.stringify({ value, base, at: Date.now() })); } catch { /* storage off */ }
}

export function clearDraft(key) {
  try { localStorage.removeItem(DRAFT_PREFIX + key); } catch { /* storage off */ }
}

// The server refused a save because the notes changed since the edit began (see HANDOFF: notesBase).
export const isNotesConflict = (err) => /someone else changed/i.test(err?.message || '');
